module.exports = __webpack_public_path__ + "static/ss15.e75e740e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss15.jpg
// module id = 1192
// module chunks = 81679748166845